<template>
  <div
    v-if="isTeamMember"
    :title="statusText"
  >
    <i
      class="help-center-ssr-lightning__icon"
      :class="statusIcon"
    />
  </div>
</template>

<script setup>
import useHelpCenterVisitor from 'help-center/composables/useHelpCenterVisitor'

const statusIcon = globalThis.sourceUrl
  ? 'far fa-bolt-lightning'
  : 'far fa-bolt-slash'

const statusText = globalThis.sourceUrl
  ? 'Server-side rendered page'
  : 'Client-side rendered page'

const { isTeamMember } = useHelpCenterVisitor()
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-ssr-lightning {
  &__icon {
    @include help-center-icon(16);
    color: var(--help-center-accent);
  }
}
</style>
